import React from 'react';
import useGet from "../../components/hooks/useGet";
import {useParams} from "react-router-dom";
import {BackendForm} from "../../components/forms";
import {Pages} from "../../components/layout";
import FloatingLabelField from "../../components/forms/FloatingLabelField";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import moment from "moment";
import {defaultDateTimeFormat} from "../../utils/date";
import { FormGroup, FormLabel } from "react-bootstrap";
import {adminRoutes} from "../../utils/routes";
import SubscriptionCard from "../../components/subscriptions/SubscriptionCard";
import {concepts, explanations, Group, Subscription} from "fearless-common";
import Loading from "../../components/Loading";
import GroupDeleteButton from "../../components/groups/GroupDeleteButton";
import GroupUserManagement from "../../components/groups/GroupUserManagement";
import GenerateGroupJoinLink from "../../components/groups/GenerateGroupJoinLink";
import GroupRestoreButton from "../../components/groups/GroupRestoreButton";
import useTitle from "../../components/hooks/useTitle";

const labelClassName = 'col-5'

function AdminGroup() {
    const { groupId: groupIdString } = useParams() as Readonly<{ groupId: string }>;
    const groupId = parseInt(groupIdString, 10);
    const { data: group, isLoading, reload } = useGet<Group & { subscriptions?: Subscription[] }>({
        endpoint: `/admin/groups/${groupId}?_with[]=users&_withTrashed=1`
    });

    useTitle(`Admin ${concepts.Group}`);

    return (
        <Pages.Centred>
            <Pages.BackButton href={adminRoutes.groups}>{concepts.Groups}</Pages.BackButton>
            <h1>Group: {group?.name}</h1>
            <div className="d-flex gap-4 mb-3">
              {group?.deleted_at && <span>Archived at: {moment(group?.deleted_at).format(defaultDateTimeFormat)}</span>}
              <span>Signed up: {moment(group?.created_at).format(defaultDateTimeFormat)}</span>
              <span>Last updated: {moment(group?.updated_at).format(defaultDateTimeFormat)}</span>
            </div>
            {isLoading && <Loading />}
            {group && (
                <>
                    <Row>
                        <Col>
                            <BackendForm
                                initialValues={group}
                                targetEndpoint={`/admin/groups/${groupId}`}
                                targetMethod="PUT"
                                onSuccess={(resp) => {

                                }}
                            >
                                <h5>Information</h5>
                                <FloatingLabelField name="name" label="Name"/>
                            </BackendForm>

                            <h5 className="px-0 mt-4">Technical details</h5>
                            <FormGroup className="d-flex">
                                <FormLabel className={labelClassName}>Is subscribed</FormLabel>
                                {group?.is_subscribed ? 'Yes' : 'No'}
                            </FormGroup>

                            {group?.subscriptions?.map((subscription) => (
                              <div key={subscription.id} className="d-inline-block border border-2">
                                <SubscriptionCard subscription={subscription} group={group} />
                              </div>
                            ))}

                            {group && (
                              <>
                                <h5 className="mt-5">{concepts.GroupMember} management</h5>
                                <GroupUserManagement
                                    group={group}
                                    reload={reload}
                                    onSuccess={() => {
                                        reload();
                                    }}
                                />
                              </>
                            )}
                        </Col>
                        <Col sm={4}>
                            <h5>{concepts.CustomerService}</h5>
                            <h6>Group join link to quickly add many members</h6>
                            <small className="line-height-1-2">
                                All groups have a join link, which users can find on the group page. This link allows
                                anyone with the link to join the group.
                            </small>
                            <small className="line-height-1-2 d-block mt-3">
                                <GenerateGroupJoinLink groupId={groupId} />
                            </small>
                            {!group.deleted_at ? (
                                <>
                                    <h6 className="mt-5">Archive {concepts.Group}</h6>
                                    <small className="line-height-1-2">{explanations.deleteGroup}</small>
                                    <br />
                                    <GroupDeleteButton group={group} />
                                </>
                            ) : (
                                <>
                                    <h6 className="mt-5">Restore {concepts.Group}</h6>
                                    <small className="line-height-1-2">{explanations.deleteGroup}</small>
                                    <br />
                                    <GroupRestoreButton group={group}/>
                                </>
                            )}
                        </Col>
                    </Row>
                </>
            )}

        </Pages.Centred>
    );
}

export default AdminGroup;
